'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.Accent = Accent;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _lodash = require('lodash');

var _propTypes = require('prop-types');

var _styles = require('@material-ui/core/styles');

var _colorManipulator = require('@material-ui/core/styles/colorManipulator');

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Accent(_ref, context) {
  var classes = _ref.classes;

  var contextClass = (0, _lodash.get)(context, 'praxis.accentClass', '');
  var accentClassList = (0, _classnames3.default)(classes.root, (0, _defineProperty3.default)({}, contextClass, contextClass.length));

  return React.createElement('div', { className: accentClassList });
}

Accent.defaultProps = {
  classes: {}
};

Accent.contextTypes = {
  praxis: (0, _propTypes.shape)({
    accentClass: _propTypes.string
  })
};

var styleSheet = function styleSheet(_ref2) {
  var palette = _ref2.palette;

  var navBackgroundColor = palette.primary.main;
  var accentBackgroundColor = palette.common.white;

  if ((0, _colorManipulator.getContrastRatio)(navBackgroundColor, accentBackgroundColor) < 7) {
    accentBackgroundColor = palette.common.black;
  }

  return {
    root: {
      background: accentBackgroundColor,
      position: 'absolute',
      height: 2,
      left: 0,
      right: 0,
      bottom: 0
    }
  };
};

exports.default = (0, _styles.withStyles)(styleSheet)(Accent);